<div>
    <label class="upload_label">
        <input type="file" [accept]="supportedFileExtensions.join(',')" (click)="clearAllImport($event)" (change)="validateImportedFileType($event)"
        [multiple]="multiSelectEnabled" />
        <span *ngIf="imgPath"><img class="image-import" src="{{'assets/images/svg/'+imgPath}}" alt=""></span> 
        <span class="btn-import">{{ buttonName }}</span>
    </label>
</div>